import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
  OutlinedInput,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  Backdrop,
  IconButton,
  InputAdornment,
  Menu,
  Grid,
  Autocomplete,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import UndoIcon from "@mui/icons-material/Undo";
import CampaignIcon from "@mui/icons-material/Campaign";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SendIcon from "@mui/icons-material/Send";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import NotesIcon from "@mui/icons-material/Notes";
import ProductSelector from "./ProductSelector";
import useOrderForm from "./OrderFormHook";
import OrderPreview from "./OrderPreview";
import { isTestEnv } from "../globals";
import { BRAND, BRAND_DARK, BRAND_LIGHT_BG } from "../constants/salesPromotionsTheme";
import React from "react";

const OrderForm = ({ roles, open, contactCodes, setOpen, setFlag, editingOrder, duplicatingOrder }) => {
  const {
    holidays,
    onClose,
    translation,
    selectedRole,
    anchorEl,
    handleClose,
    handleSubmit,
    isSubmitted,
    formErrors,
    handleInputChange,
    formData,
    setFormData,
    marketingClient,
    setMarketingClient,
    openCities,
    setOpenCities,
    hasUserInput,
    setHasUserInput,
    showAlert,
    setShowAlert,
    isLoadingSites,
    siteOptions,
    handleAddressChange,
    isReadOnlyAddress,
    tempCity,
    snackbar,
    handleCloseSnackbar,
    products,
    productsLoadProgress,
    fetchLiveProductData,
    debouncedInputChange,
    handleOpenProductSelector,
    handleOpenProductSelectorSingleRequest,
    fetchSiteOptions,
    handleRoleChange,
    handleClick,
    minDeliveryDate,
    shouldDisableDate,
    handleDateChange,
    isFetching,
    options,
    isLoading,
    isLoadingProducts,
    handleCloseProductSelector,
    productSelectorOpen,
    handleProductsChange,
    handleFileRemove,
    handleFileChange,
    getCurrentValue,
    handleAutoCompleteChange,
    getCustomersInfo,
    previewOpen,
    handlePreviewClose,
    handlePreviewConfirm,
    isEditMode,
    isDuplicateMode
  } = useOrderForm(roles, open, contactCodes, setOpen, setFlag, editingOrder, duplicatingOrder);

  if (holidays && !holidays.length && isTestEnv) {
    console.log(translation.dataError);
  } else
    return (
      <Dialog
        open={holidays && holidays.length && open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: "50%",
              background: "linear-gradient(135deg, rgba(25,118,210,0.14) 0%, rgba(25,118,210,0.05) 100%)",
              display: "flex",
            }}
          >
            <CampaignIcon sx={{ color: BRAND, fontSize: 24 }} />
          </Box>
          <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
            {isEditMode ? `עריכת הזמנה: ${editingOrder?.ordName || ''}` : isDuplicateMode ? translation.duplicateOrderForm : translation.orderForm}
          </Typography>
          <Button
            onClick={handleClick}
            variant="outlined"
            sx={{
              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 600,
              color: BRAND,
              borderColor: BRAND,
              '&:hover': { borderColor: BRAND_DARK, bgcolor: BRAND_LIGHT_BG },
            }}
          >
            {selectedRole?.Name || translation.selectRole}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {roles.map((role) => (
              <MenuItem key={role._id} onClick={() => handleRoleChange(role)}>
                {role.Name}
              </MenuItem>
            ))}
          </Menu>
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              margin: "auto",
              borderRadius: "4px",
              padding: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderInlineStart: `4px solid ${BRAND}`,
                bgcolor: "#f5f9ff",
                borderRadius: 3,
                p: 2.5,
              }}
            >
            <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 0.75, color: BRAND, fontWeight: 700 }}>
              <PersonOutlineIcon fontSize="small" />
              פרטי לקוח והזמנה
            </Typography>
            <FormControl
              fullWidth
              error={isSubmitted && !!formErrors.selectedOrderingCustomer}
            >
              <>
           
                <InputLabel id="ordering-customer-label">
                  {translation.selectOrderingCustomer}
                </InputLabel>
                <Select
                  labelId="ordering-customer-label"
                  name="selectedOrderingCustomer"
                  value={
                    formData.selectedOrderingCustomer !== ""
                      ? selectedRole?.properties[0]?.SalesPromotions.ordererCustomer
                          ?.find(customer => customer.custdes === formData.selectedOrderingCustomer)?.custname
                          || formData.selectedOrderingCustomer
                      : selectedRole?.properties[0]?.SalesPromotions.ordererCustomer
                          ?.length == 1
                        ? selectedRole.properties[0]?.SalesPromotions
                            .ordererCustomer[0].custname
                        : formData.selectedOrderingCustomer
                  }
                  onChange={handleInputChange}
                  required
                  input={
                    <OutlinedInput label={translation.selectOrderingCustomer} />
                  }
                >
                  {!selectedRole?.properties[0]?.SalesPromotions.ordererCustomer
                    ?.length ? (
                    <MenuItem>
                      <em>{translation.noOptions}</em>
                    </MenuItem>
                  ) : (
                    selectedRole.properties[0]?.SalesPromotions.ordererCustomer.map(
                      (customer, index) => (
                        <MenuItem key={index} value={customer?.custname}>
                          {customer?.custdes}
                        </MenuItem>
                      )
                    )
                  )}
                </Select>
              </>

              {isSubmitted && formErrors.selectedOrderingCustomer && (
                <FormHelperText>
                  {formErrors.selectedOrderingCustomer}
                </FormHelperText>
              )}
            </FormControl>

            {marketingClient ? (
              <>
                <TextField
                  name="nsDesCustomer"
                  value={formData.nsDesCustomer}
                  onChange={handleInputChange}
                  placeholder={translation.enterCustomerName}
                  fullWidth
                  variant="outlined"
                  required // Add this prop
                  error={!formData.nsDesCustomer} // Add error state based on validation
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setMarketingClient(false);
                            setFormData((prevData) => ({
                              ...prevData,
                              selectedRecivingCustomer: "",
                              nsDesCustomer: "",
                              site: "",
                            }));
                          }}
                        >
                          <UndoIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& legend": {
                      maxWidth: "0",
                    },
                  }}
                />
                <TextField
                  name="phonenum"
                  value={formData.address?.phonenum || ""}
                  onChange={handleAddressChange}
                  placeholder={translation.enterCustomerPhone}
                  fullWidth
                  variant="outlined"
                  required // Add this prop
                  error={!formData.address.phonenum} // Add error state based on validation
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    "& legend": {
                      maxWidth: "0",
                    },
                  }}
                />
              </>
            ) : (
              <FormControl fullWidth>
                <InputLabel id="receiving-customer-label">
                  {translation.selectReceivingCustomer}
                </InputLabel>
                <Select
                  labelId="receiving-customer-label"
                  name="selectedRecivingCustomer"
                  value={
                    formData.selectedRecivingCustomer !== ""
                      ? selectedRole?.properties[0]?.SalesPromotions.receiveCustomer
                          ?.find(customer => customer.custdes === formData.selectedRecivingCustomer)?.custname
                          || formData.selectedRecivingCustomer
                      : formData.selectedRecivingCustomer
                  }
                  onChange={handleInputChange}
                  input={
                    <OutlinedInput
                      label={translation.selectReceivingCustomer}
                    />
                  }
                >
                  {formData.selectedRecivingCustomer && (
                    <MenuItem value="">
                      <em>{translation.cancelSelection}</em>
                    </MenuItem>
                  )}

                  {!selectedRole?.properties[0]?.SalesPromotions
                    ?.receiveCustomer?.length ? (
                    <MenuItem disabled>
                      <em>{translation.noOptions}</em>
                    </MenuItem>
                  ) : (
                    selectedRole?.properties[0]?.SalesPromotions?.receiveCustomer
                      .reduce((acc, customer) => {
                        if (
                          !acc.some(
                            (existingCustomer) =>
                              existingCustomer._id === customer._id
                          )
                        ) {
                          acc.push(customer);
                        }
                        return acc;
                      }, [])
                      .map((customer) => (
                        <MenuItem key={customer._id} value={customer.custname}>
                          {customer.custdes}
                        </MenuItem>
                      ))
                  )}
                </Select>
              </FormControl>
            )}

            <FormControl fullWidth>
              <Autocomplete
                fullWidth
                value={getCurrentValue()}
                onChange={handleAutoCompleteChange}
                onOpen={fetchSiteOptions}
                options={siteOptions}
                getOptionLabel={(option) =>
                  option ? `${option.code} ${option.codedes}` : ""
                }
                loading={isLoadingSites}
                noOptionsText={translation.noSitesAvailable}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={translation.selectSites}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoadingSites ? (
                            <CircularProgress size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  return option.code === value.code;
                }}
              />
            </FormControl>

            <FormControl
              fullWidth
              error={isSubmitted && !!formErrors.selectedProducts}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <TextField
                  label={translation.selectedProductsCount}
                  value={formData.selectedProducts.length}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{ flexGrow: 1 }}
                  required
                />

                <Button
                  variant="contained"
                  onClick={handleOpenProductSelector}
                  startIcon={<ShoppingCartIcon />}
                  sx={{
                    borderRadius: 2.5,
                    textTransform: "none",
                    fontWeight: 600,
                    bgcolor: BRAND,
                    '&:hover': { bgcolor: BRAND_DARK },
                  }}
                >
                  {translation.editOrderProducts}
                </Button>
         
              </Box>
              {isSubmitted && formErrors.selectedProducts && (
                <FormHelperText>{formErrors.selectedProducts}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={isSubmitted && !!formErrors.contractCode}
            >
              <InputLabel id="contract-code-label">
                {translation.selectContractCode}
              </InputLabel>
              <Select
                labelId="contract-code-label"
                name="contractCode"
                value={formData.contractCode}
                onChange={handleInputChange}
                input={<OutlinedInput label={translation.selectContractCode} />}
                required
              >
                {contactCodes.map((code) => (
                  <MenuItem key={code.code} value={code.code}>
                    {code.des}
                  </MenuItem>
                ))}
              </Select>
              {isSubmitted && formErrors.contractCode && (
                <FormHelperText>{formErrors.contractCode}</FormHelperText>
              )}
            </FormControl>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderInlineStart: `4px solid ${BRAND}`,
                bgcolor: "#f5f9ff",
                borderRadius: 3,
                p: 2.5,
              }}
            >
            <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 0.75, color: BRAND, fontWeight: 700 }}>
              <LocalShippingIcon fontSize="small" />
              כתובת ומשלוח
            </Typography>
            {formData.site === "" && (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label={translation.street}
                    name="street"
                    value={formData.address?.street || ""}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleAddressChange}
                    InputProps={{
                      readOnly: !marketingClient,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label={translation.house}
                    name="hoNumber"
                    value={formData.address?.hoNumber || ""}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleAddressChange}
                    InputProps={{
                      readOnly: !marketingClient,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label={translation.floor}
                    name="floor"
                    value={formData.address?.floor || ""}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleAddressChange}
                    InputProps={{
                      readOnly: !marketingClient,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label={translation.apartment}
                    name="apNumber"
                    value={formData.address?.apNumber || ""}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleAddressChange}
                    InputProps={{
                      readOnly: !marketingClient,
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <Autocomplete
                    open={openCities}
                    onOpen={() => setOpenCities(true)}
                    onClose={() => setOpenCities(false)}
                    value={formData.address?.city || ""}
                    onChange={(event, newValue) => {
                      // instead of passing the whole event object, pass only the relevant value
                      handleAddressChange({
                        target: {
                          name: "city",
                          value: newValue || "", // make sure the value is always defined
                        },
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                      if (!hasUserInput) {
                        setHasUserInput(true);
                      }
                      // pass the value itself instead of the event object
                      debouncedInputChange(newInputValue);
                    }}
                    options={
                      hasUserInput
                        ? options
                        : [formData.address?.city].filter(Boolean)
                    }
                    disabled={!marketingClient}
                    loading={isFetching}
                    fullWidth
                    filterOptions={(x) => x}
                    noOptionsText={
                      tempCity && tempCity.length < 2
                        ? translation.citySearchMinChars
                        : translation.noResults
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={translation.city}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: !marketingClient,
                          sx: {
                            "&.Mui-readOnly": {
                              "& input": {
                                color: "text.primary",
                                WebkitTextFillColor: "unset",
                              },
                            },
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label={translation.country}
                    name="country"
                    value={formData.address?.country || ""}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleAddressChange}
                    InputProps={{
                      readOnly: !marketingClient,
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>
            )}
            <FormControl
              fullWidth
              error={isSubmitted && !!formErrors.deliveryDate}
            >
              <TextField
                label={translation.deliveryDate}
                type="date"
                value={formData.deliveryDate || ""}
                onChange={(e) => handleInputChange({ target: { name: 'deliveryDate', value: e.target.value } })}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: minDeliveryDate }}
                fullWidth
              />
              {isSubmitted && formErrors.deliveryDate && (
                <FormHelperText>{formErrors.deliveryDate}</FormHelperText>
              )}
            </FormControl>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderInlineStart: `4px solid ${BRAND}`,
                bgcolor: "#f5f9ff",
                borderRadius: 3,
                p: 2.5,
              }}
            >
            <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 0.75, color: BRAND, fontWeight: 700 }}>
              <NotesIcon fontSize="small" />
              הערות וקבצים
            </Typography>
            <TextField
              multiline
              rows={4}
              name="drivertext"
              label={translation.driverNotes}
              value={formData.drivertext}
              onChange={handleInputChange}
              fullWidth
            />

            <TextField
              multiline
              rows={4}
              name="orderstext"
              label={translation.customerOrderText}
              value={formData.orderstext}
              onChange={handleInputChange}
              fullWidth
            />

            <TextField
              multiline
              rows={4}
              name="internalDialogtext"
              label={translation.internalDialog}
              value={formData.internalDialogtext}
              onChange={handleInputChange}
              fullWidth
            />

            <Button
              variant="contained"
              component="label"
              startIcon={<UploadFileIcon />}
              sx={{
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 600,
                bgcolor: BRAND,
                '&:hover': { bgcolor: BRAND_DARK },
                alignSelf: "flex-start",
              }}
            >
              {translation.uploadFiles}
              <input type="file" hidden multiple onChange={handleFileChange} />
            </Button>
            <Typography variant="body2" color="text.secondary">
              {formData.selectedFiles.length} {translation.filesSelected}
            </Typography>

            {formData.selectedFiles.length > 0 && (
              <List dense sx={{ py: 0 }}>
                {formData.selectedFiles.map((file, index) => (
                  <ListItem
                    key={index}
                    sx={{ bgcolor: "#fff", borderRadius: 2, mb: 0.5, border: "1px solid rgba(0,0,0,0.06)" }}
                    secondaryAction={
                      <IconButton
                        onClick={() => handleFileRemove(index)}
                        aria-label="delete"
                        size="small"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    }
                  >
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <InsertDriveFileIcon sx={{ color: BRAND }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={file.filename || file.name} />
                  </ListItem>
                ))}
              </List>
            )}
            </Box>
          </Box>
          <DialogActions sx={{ padding: "12px 16px" }}>
            <Button
              onClick={onClose}
              sx={{
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 600,
                color: BRAND,
              }}
            >
              {translation.cancel}
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              startIcon={<SendIcon />}
              sx={{
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 600,
                bgcolor: BRAND,
                '&:hover': { bgcolor: BRAND_DARK },
              }}
            >
              {isEditMode ? "עדכן הזמנה" : translation.sendOrder}
            </Button>
          </DialogActions>
        </DialogContent>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>

        <ProductSelector
          products={
            products.length
              ? products.sort((a, b) => b.quantity - a.quantity)
              : products
          }
          selectedProducts={formData.selectedProducts}
          onProductsChange={handleProductsChange}
          open={productSelectorOpen}
          onClose={handleCloseProductSelector}
          isLoadingProducts={isLoadingProducts}
          onFetchLiveData={fetchLiveProductData}
          productsLoadProgress={productsLoadProgress}
        />

        <OrderPreview
          open={previewOpen}
          onClose={handlePreviewClose}
          onConfirm={handlePreviewConfirm}
          orderData={formData}
          customerDescription={getCustomersInfo()}
          translation={translation}
          isLoading={isLoading}
        />

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {showAlert && (
          <Alert
            severity="warning"
            action={
              <Stack direction="row" spacing={1}>
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => setShowAlert(false)}
                >
                  {translation.cancel}
                </Button>
                <Button
                  color="warning"
                  size="small"
                  onClick={() => {
                    setShowAlert(false);
                    handleSubmit(null, true);
                  }}
                >
                  {translation.approve}
                </Button>
              </Stack>
            }
          >
            {translation.warning}
          </Alert>
        )}
      </Dialog>
    );
};

export default OrderForm;
